import { MaskitoOptions } from '@maskito/core'

// +7 (9##) ###-##-##
export const phoneMaskOptions: MaskitoOptions = {
  mask: [
    '+',
    '7',
    ' ',
    '(',
    '9',
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ],
}

// ###-###-###-##
export const snilsMaskOptions: MaskitoOptions = {
  mask: [
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ],
}

// ###### Руб
export const rubleMaskOptions: MaskitoOptions = {
  mask: ({ value }) => {
    const digitsMask = Array.from(value.replaceAll(' Руб', '')).map(() => /\d/)

    if (!digitsMask.length) {
      return [/\d/]
    }

    return [...digitsMask, ' ', 'Р', 'у', 'б']
  },
}
